<script>
  import { createEventDispatcher, afterUpdate, onDestroy, onMount } from "svelte"
  import notify from "../../../../../Script/notify"
  import templateStore from "../../../../../Stores/metadataStore"

  export let id
  export let value
  export let placeholder = "Enter Value"
  // export let extraClass = "border-transparent font-bold" //[#a0a1a533]
  let extraClass = "border-[#a0a1a580] font-bold" //[#a0a1a533]

  //To differentiate key and value of the json to apply regex validation and value of the json
  export let key = false
  export let isFocused = false
  export let keyValue

  /** @type {Number} Maximum number of characters allowed for metadata key and value. */
  export let maxCharacters

  const dispatch = createEventDispatcher()

  /** @type {String} - invalid input CSS class*/
  let invalidClass = ""

  /**
   * @typedef {Object} revertNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {revertNotification}
   */
  let revertNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} maxNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {maxNotification}
   */
  let maxNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} emptyNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {emptyNotification}
   */
  let emptyNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @type {HTMLElement} - input element
   */
  let input

  /**
   * @typedef {Object} Notification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {Notification}
   */
  let notification = {
    /**
     * Closes the notification.
     */
    close() {},
  }
  /**
   * @typedef {Object} Notification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {Notification}
   */
  let emptyKeyNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} digitNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {digitNotification}
   */
  let digitNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} focusNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {focusNotification}
   */
  let focusNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} digitRevertNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {digitRevertNotification}
   */
  let digitRevertNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /** @type {Number} Timer used for tracking time. */
  let timer

  /** @type {String} CSS class for disabled state. */
  let disabledClass = ""

  /** @type {String} Tooltip content. */
  let toolTip

  /**
   * @type {String} - Regex to allow numbers in between characters but not at the starting place
   */
  // let allowedCharsRegex = /^[A-Za-z-\s()+₹.@$%&*][A-Za-z\d-\s()+₹.@$%&*]*$/
  let allowedCharsRegex = /^[A-Za-z\s()+₹.@$%&*-][A-Za-z\d\s()+₹.@$%&*-]*$/
  /**
   * To focus newly creating input field based on its input value
   */
  onMount(() => {
    if (isFocused && input && !input.value) {
      input.focus()
    }
  })

  afterUpdate(() => {
    let count = 0

    /**
     * Updates the template store with new changed keys.
     *
     * @param {Array<Object>} templateData - The template data array.
     * @returns {Array<Object>} The updated template data array.
     */
    templateStore.update((templateData) => {
      // Use a for loop instead of find to iterate through templates.
      for (let i = 0; i < templateData.length; i++) {
        const templateJson = templateData[i]
        if (templateJson.id.toLowerCase() === id.toLowerCase()) {
          count++
          if (count === 2) {
            templateJson.id = 0
            break
          }
        }
      }

      return templateData
    })
    if (count === 2 && key && input.value) {
      notification.close()
      // Filter the template store to remove templates with ID 0.
      $templateStore = $templateStore.filter((templateData) => templateData.id !== 0)

      const info = "PAGE: Edit document template\nEVENT: While checking metadata duplicate keys reactively"
      // Displays a danger notification indicating that same keys are not allowed.
      notification = notify.danger("Same key not allowed", info)
      return
    }
    if (count === 2 && key && !input.value) {
      emptyKeyNotification.close()
      // Filter the template store to remove templates with ID 0.
      $templateStore = $templateStore.filter((templateData) => templateData.id !== 0)

      const info = "PAGE: Edit document template\nEVENT: While checking metadata empty keys reactively"
      // Displays a danger notification indicating that same keys are not allowed.
      emptyKeyNotification = notify.danger("Kindly enter a value for key", info)
      return
    }
  })

  /**
   * @description - function to check not to exceed max characters
   */
  const checkMaxCharacters = () => {
    //closing maxNotification (if any)
    maxNotification.close()
    //check input value length is greater than maximum characters
    if (input.value.length > maxCharacters) {
      //returning values only in range below max characters using slice method after a delay of 20ms
      setTimeout(() => {
        input.value = input.value.slice(0, maxCharacters)
      }, 20)
      //Throw notification for exceeding max Characters
      maxNotification = notify.info(`Cannot enter more than ${maxCharacters} characters`)
    }
  }

  /**
   * Disables the input based on the provided ID and input element.
   * @param {String} id - The ID of the input element.
   * @param {HTMLInputElement} input - The input element to disable.
   */
  const disableInput = (id, input) => {
    // Check if the ID matches one of the specified values, and if `key` and `input` are truthy.
    if ((id == "issuer.signatory" || id == "receiver.name" || id == "document.type") && key && input) {
      // Disable the input element.
      input.disabled = true

      // Add the CSS class "cursor-not-allowed" to the input element's class list.
      disabledClass = "cursor-not-allowed"

      // Set the tooltip text for the input element.
      toolTip = "Cannot edit Mandatory field"
    }

    if (id == "receiver.name" && !key && input) {
      input.disabled = true
      // disabledClass = "disabled:cursor-not-allowed"
      toolTip = "Cannot edit name value"
      placeholder = "To be filled during publishing"
    } else if (id == "document.type") {
      placeholder = "( Optional ) eg., Course Certificate, ID Card, Offer Letter,..."
    }
  }

  //calling disableInput function reactively to monitor id and input changes
  $: disableInput(id, input)

  /**
   * Validates the input field to allow only specific characters.
   * @param {Event} e - The event object.
   */
  const checkSpecialChars = (e) => {
    try {
      const info = "PAGE: Edit Document template\nEVENT: Validating invalid characters for the metedata input during onPaste/ onKeypress"

      // Check if input and key exist
      if (key && input) {
        // Close any existing notifications
        revertNotification.close()

        // Destructure the type and key properties from the event object
        let { type, key } = e

        if (type === "keypress" && !allowedCharsRegex.test(input.value + key)) {
          try {
            // Close any existing notifications
            revertNotification.close()
            //preveting default behaviour and suppress next invalid key enter
            e.preventDefault()

            // Append the key to the input value
            input.value += key

            // Display a notification about allowed characters and restrictions
            revertNotification = notify.danger(`Allowed characters: <strong>Letters</strong>, <strong>Numbers</strong>, and <strong>()+₹.@$%&*-</strong> (Numbers at the leading place are not allowed)`, info)

            setTimeout(() => {
              // Remove the last character from the input value after a delay
              input.value = input.value.slice(0, -1)
            }, 100)
          } catch (error) {
            // console.error(error)
          }
        } else if (type === "paste") {
          // Handle the pasted text
          revertNotification.close()
          e.preventDefault()

          let clipboardData = e.clipboardData || window.clipboardData
          // Retrieve the pasted text from the clipboard
          let pastedText = clipboardData.getData("text/plain")
          // Remove any characters that don't match the allowed characters regex
          let cleanedText = pastedText.replace(/[^A-Za-z\d-\s()+₹.@$%&*-]/g, "")
          if (!input.value) {
            // Remove leading numbers followed by a non-alphabetic character
            cleanedText = cleanedText.replace(/^\d+([^A-Za-z]|$)/, "")
          }

          if (!allowedCharsRegex.test(pastedText)) {
            cleanedText = cleanedText.trim()

            if (cleanedText !== pastedText) {
              // Display a notification about removed characters and restrictions
              revertNotification = notify.danger("Only &emsp;<br/> <strong>Letters</strong> &emsp;<br/> <strong>Numbers</strong> and &emsp;<br/> <strong>()+₹.@$%&*-</strong> are allowed. Removing Numbers at Leading place and non-specified Characters", info)
            }
          }

          // Get the selected text range
          const selectionStart = input.selectionStart
          const selectionEnd = input.selectionEnd

          // Replace the selected text with the cleaned text
          input.value = input.value.substring(0, selectionStart) + cleanedText + input.value.substring(selectionEnd)

          // Move the cursor to the end of the inserted text
          const newCursorPosition = selectionStart + cleanedText.length
          input.setSelectionRange(newCursorPosition, newCursorPosition)

          // Perform additional actions related to input changes
          inputChange()

          // Check for maximum character limit
          checkMaxCharacters()
        }
      }
    } catch (error) {
      // console.error(error)
    }
  }

  /**
   * @description - function to change input key and value in accordian
   */
  /**
   * Function to handle input change events.
   */
  const inputChange = async () => {
    const info = "PAGE: Edit Document template\nEVENT: Validating metedata input during onChange"

    // Check if both `key` and `input` variables are truthy.
    if (key && input) {
      // Close the digitRevertNotification if it is open.
      digitRevertNotification.close()

      // Clean the text by removing characters that are not allowed.
      let cleanedText = input.value.replace(/[^A-Za-z\d-\s()+₹.@$%&*-]/g, "")

      // If the cleaned text does not match the allowedCharsRegex, remove leading digits.
      if (!allowedCharsRegex.test(cleanedText)) {
        cleanedText = cleanedText.replace(/^\d+([^A-Za-z]|$)/, "")
        cleanedText = cleanedText.replace(/^\d/, "")

        // If the input value still does not match the allowedCharsRegex, trim the text.
        if (!allowedCharsRegex.test(input.value)) {
          cleanedText = cleanedText.trim()

          // If the cleaned text is different from the input value, show a notification.
          if (cleanedText !== input.value) {
            digitRevertNotification = notify.danger("Numbers not allowed at Leading place", info)
          }
        }
      }

      // Update the input value with the cleaned text.
      input.value = cleanedText
    }

    // Check if both `input` and `key` variables are truthy.
    if (input && key) {
      // Check if the input value contains only digits.
      if (/^\d+$/.test(input.value)) {
        // Close the digitNotification if any
        digitNotification.close()

        // Clear the input value.
        input.value = ""

        // Show a notification indicating that only numbers are not allowed.
        digitNotification = notify.danger("Only Numbers not allowed", info)
      }
    }
  }

  /**
   * @description - Closing existing notifications and clearing timer while destroying page.
   */
  onDestroy(() => {
    // Check if the `notification` variable exists and close it if it does.
    // if (notification) {
    //   notification.close()
    // }

    // Clear the timeout specified by the `timer` variable.
    clearTimeout(timer)
  })

  /**
   * Marks an input element as invalid by applying appropriate styles or attributes.
   * @param {string} id - The ID of the input element.
   * @param {HTMLElement} input - The input element to be marked as invalid.
   * @returns {void}
   */
  const invalidInput = () => {
    invalidClass = !input.value && key ? "border-red-500 ring-red-600 placeholder:text-red-500 animate-shake focus:placeholder-gray-200 focus:border-blue-500 focus:ring-blue-500" : ""
  }
</script>

<div data-tooltip={toolTip} tooltip-position="top">
  <input
    required
    readonly={!key && !keyValue}
    bind:this={input}
    on:input={() => {
      // notification.close()
      timer = setTimeout(checkMaxCharacters, 10)
      // timer = setTimeout(inputChange, 10)
      inputChange()
    }}
    on:paste={checkMaxCharacters}
    on:paste={checkSpecialChars}
    on:blur={() => {
      input.value = input.value.trim()
      dispatch("inputChange", {
        id: id,
        value: input.value,
      })
      invalidInput()
    }}
    {value}
    on:keypress={checkSpecialChars}
    class="{extraClass} {disabledClass} {id !== 'receiver.name' ? 'read-only:pointer-events-none' : ''} {invalidClass ? invalidClass : 'focus:border-blue-500 focus:ring-blue-500'} relative w-full appearance-none rounded-md border bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 read-only:cursor-not-allowed focus:ring-1 focus:ring-blue-500 focus-visible:border-blue-500 dark:text-slate-200"
    type="text"
    {placeholder}
  />
</div>
